import React from "react";

import Select, { components } from "react-select";
import { Scrollbars } from "react-custom-scrollbars-2";
import { withSelectedCars } from "../../containers/containerSelectedCars";
import { withSelectedReports } from "../../containers/containerSelectedReports";

import Icon from "./../static/icon";

import variables from "./../../../values.scss";
import "./reportSelect.scss";

const NO_ITEMS = "Вариантов нет";

// const allOption = {
//   title: 'Выбрать все',
//   id: '*'
// }

const NoOptionsMessage = (props) => {
  return <components.NoOptionsMessage {...props}>{NO_ITEMS}</components.NoOptionsMessage>;
};

const ClearIndicator = (props) => {
  return (
    <components.ClearIndicator {...props}>
      <Icon name="x" />
    </components.ClearIndicator>
  );
};

const MultiValueRemove = () => {
  return null;
};

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <Icon name="direction-desc" />
    </components.DropdownIndicator>
  );
};

const MenuList = (props) => {
  return (
    <components.MenuList {...props}>
      {props.children.length > 5 ? (
        <Scrollbars style={{ height: "195px" }} autoHide={true}>
          {props.children}
        </Scrollbars>
      ) : (
        props.children
      )}
    </components.MenuList>
  );
};

const Option = (props) => {
  return (
    <components.Option {...props}>
      <div className={props.isSelected ? "checkOption selected" : "checkOption"}>
        {/*     <span className='check'></span> */}
        <span className="option">{props.children}</span>
      </div>
    </components.Option>
  );
};

// for simple select
const handleChangeValue = (props, value) => {
  const { handleChange, selectedCars, onChangeSelectedCar } = props;

  const _selectedCars = selectedCars.filter((x) => {
    if (x.reports.length > 0) {
      return x.reports.some((report) => {
        return report.id === value.id;
      });
    }
    return false;
  });
  
  onChangeSelectedCar(_selectedCars);

  handleChange([value]);
};

const ReportSelect = (props) => {
  const { value, options, placeholder } = props;
  const colourStyles = {
    clearIndicator: (styles) => {
      return {
        ...styles,
        color: variables.multiDropDownArrow,
        fontSize: "10px",
        cursor: "pointer",
      };
    },
    dropdownIndicator: (styles) => {
      return {
        ...styles,
        color: variables.multiDropDownArrow,
        fontSize: "6px",
        cursor: "pointer",
      };
    },
    multiValue: (styles) => {
      return {
        ...styles,
        backgroundColor: "transparent",
      };
    },
    multiValueLabel: (styles) => {
      return {
        ...styles,
        fontSize: "11px",
        fontWeight: "normal",
        padding: "0px !important",
        backgroundColor: "transparent",
        color: variables.multiSelectLabel,
        textTransform: "normal",
      };
    },
    multiValueRemove: (styles) => {
      return {
        ...styles,
        backgroundColor: "none",
        paddingRight: "0px",
        fontSize: "8px",
        ":hover": {
          backgroundColor: "none",
        },
      };
    },
    option: (styles, { isFocused }) => {
      return {
        ...styles,
        backgroundColor: isFocused ? variables.multiSelectFocusOption : null,
        color: isFocused ? variables.multiSelectFocusColorOption : variables.multiSelectColorOption,
        cursor: "pointer",
      };
    },
  };

  return (
    <Select
      value={value}
      getOptionValue={(option) => `${option.id}`}
      getOptionLabel={(option) => `${option.title}`}
      options={options}
      // options={[allOption, ...options]}
      // isMulti={true}
      isClearable={false}
      captureMenuScroll={false}
      onChange={handleChangeValue.bind(this, props)}
      // isOptionSelected={setOptionSelected.bind(this, props)}
      placeholder={placeholder}
      className="container_multiCheckboxSelect"
      classNamePrefix="container_multiCheckboxSelectInner"
      components={{ DropdownIndicator, MenuList, MultiValueRemove, NoOptionsMessage, ClearIndicator, Option }}
      styles={colourStyles}
      // closeMenuOnSelect={false}
      closeMenuOnSelect={true}
      hideSelectedOptions={false}
    />
  );
};

export default React.memo(withSelectedReports(withSelectedCars(ReportSelect)));
